import React, { useState } from 'react';
import './ShowcaseLizDemo.css';

export default function ShowcaseLizDemo() {
  const [acessoLiberado, setAcessoLiberado] = useState(false);
  const [codigoAcesso, setCodigoAcesso] = useState('');
  const [erro, setErro] = useState('');
  const [mensagem, setMensagem] = useState('');
  
  const [mensagensChat, setMensagensChat] = useState<{ id: string, papel: 'usuario' | 'ia', texto: string, horario: string }[]>([
    {
      id: '1',
      papel: 'ia',
      texto: 'Olá! Eu sou a Estrela, a Parceira Pedagógica da Creche Recanto Feliz. Estou aqui para ajudar famílias e educadores a proporcionar o melhor cuidado diário com absoluto amor. Como posso te auxiliar ou qual dúvida você gostaria de tirar hoje?',
      horario: new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
    }
  ]);
  const [ouvindoPergunta, setOuvindoPergunta] = useState(false);

  const validarAcesso = (e: React.FormEvent) => {
    e.preventDefault();
    if (codigoAcesso.toUpperCase() === 'SUPERLIZ2026') {
      setAcessoLiberado(true);
      setErro('');
    } else {
      setErro('Código de acesso inválido. Por favor, verifique a senha fornecida pelo comercial.');
    }
  };

  const enviarMensagem = (e: React.FormEvent) => {
    e.preventDefault();
    if (!mensagem.trim()) return;

    const novaMensagem = {
      id: Date.now().toString(),
      papel: 'usuario' as const,
      texto: mensagem,
      horario: new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
    };

    setMensagensChat((prev) => [...prev, novaMensagem]);
    setMensagem('');
    setOuvindoPergunta(true);

    // Simulação do Backend RAG injetando a inteligência da Creche Recanto Feliz
    setTimeout(() => {
      let respostaLiz = "Compreendo perfeitamente o que você trouxe! 🌸 Na Creche Recanto Feliz, estamos todos à disposição para garantir que o desenvolvimento da criança seja incrível e que vocês fiquem sempre de coração calmo! E conte comigo pro que precisar!";
      const msg_lower = novaMensagem.texto.toLowerCase();
      
      if (msg_lower.includes('açúcar') || msg_lower.includes('doce') || msg_lower.includes('bolacha') || msg_lower.includes('achocolatado')) {
        respostaLiz = "Oi, que bom falar com você! 💖 Seguindo rigorosamente o Projeto Político Pedagógico da Creche Recanto Feliz, nós NÃO servimos nenhum tipo de açúcar refinado ou alimento ultraprocessado para crianças até os 3 aninhos. Nosso foco total é oferecer frutinhas frescas e comidinhas saudáveis que respeitam a nutrição BLW (Baby-Led Weaning) acompanhada por nossa nutricionista. Pode ficar com o coração em paz, a saúde alimentar do seu anjinho é inegociável aqui!";
      } else if (msg_lower.includes('choro') || msg_lower.includes('adaptação') || msg_lower.includes('junto') || msg_lower.includes('primeiro dia')) {
        respostaLiz = "Eu sei bem que essa fase da adaptação aperta muito o coração de vocês, viu? 🤗 Mas fique super tranquila! Na Creche Recanto Feliz a nossa adaptação é 100% humanizada. Conforme o nosso PPP determina, nos primeiros 3 dias você (ou um responsável) entrará na salinha e ficará junto! Nós aplicamos a abordagem Pikler e Montessori, focando em gerar autonomia através da segurança, respeitando estritamente o tempo do bebê.";
      } else if (msg_lower.includes('dormir') || msg_lower.includes('sono') || msg_lower.includes('soneca')) {
        respostaLiz = "Ah, a hora do soninho é um momento sagrado por aqui! 🌙 Para os bebês de berçário, seguimos totalmente o relógio individual deles, respeitando cada necessidade de descanso. Já para os nossos maiorzinhos (acima de 2 aninhos), a soneca coletiva acontece pontualmente às 13h, sempre acompanhada de uma suave música clássica, exatamente como nosso manual pedagógico orienta.";
      } else if (msg_lower.includes('febre') || msg_lower.includes('machuc') || msg_lower.includes('bateu')) {
        respostaLiz = "Entendo absolutamente a sua preocupação como mãe/pai. Mas saiba que a nossa transparência é total! 🏥 O nosso protocolo exige que em qualquer caso de febre acima de 37.5 ou qualquer mínima batidinha em brincadeiras, os pais são notificados IMEDIATAMENTE por ligação. Não omitimos absolutamente nada, e vocês podem sempre contar com a gente no primeiro sinal de desconforto.";
      }

      setMensagensChat((prev) => [
        ...prev,
        {
          id: (Date.now() + 1).toString(),
          papel: 'ia',
          texto: respostaLiz,
          horario: new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
        }
      ]);
      setOuvindoPergunta(false);
    }, 1500);
  };

  if (!acessoLiberado) {
    return (
      <div className="showcase-liz-auth-container">
        <div className="auth-card">
          <img src="/assistente_avatar.svg" alt="Demonstração da assistente" className="auth-avatar" />
          <h2>Acesso Exclusivo à Demonstração</h2>
          <p>Digite a senha recebida pela nossa equipe comercial para ver a Inteligência Artificial Pedagógica operando na prática. Cada creche batiza a sua própria assistente — aqui, na Creche Recanto Feliz, ela se chama <strong>Estrela</strong>.</p>
          
          <form onSubmit={validarAcesso} className="auth-form">
            <input 
              type="text" 
              placeholder="Código de Acesso (Ex: SUPERLIZ2026)" 
              value={codigoAcesso} 
              onChange={(e) => setCodigoAcesso(e.target.value)}
              className="auth-input"
            />
            {erro && <span className="auth-error">{erro}</span>}
            <button type="submit" className="auth-btn">Acessar Demonstração</button>
          </form>
          <small className="auth-dica">Dica: Digite SUPERLIZ2026 para entrar.</small>
        </div>
      </div>
    );
  }

  return (
    <div className="showcase-liz-demo-page">
      <header className="showcase-header">
        <div className="showcase-header-content">
          <div className="showcase-logo-area">
            <span className="badge-creche">DEMO PREMIUM</span>
            <h1>Creche Recanto Feliz 💎</h1>
            <p className="ppp-info"><strong>RAG Ativo:</strong> Projeto Político Pedagógico "Recanto Feliz" carregado (0 a 6 anos - Método Montessori / Pikler)</p>
          </div>
          <button onClick={() => setAcessoLiberado(false)} className="btn-sair">Sair da Demo</button>
        </div>
      </header>

      <main className="showcase-main">
        <div className="showcase-chat-wrapper">
          <div className="chat-header">
            <img src="/assistente_avatar.svg" alt="Avatar da assistente" className="chat-avatar" />
            <div>
              <h3>Falar com a Estrela</h3>
              <p>Teste perguntando sobre: Açúcar/Doces, Adaptação, Soneca, ou Febre.</p>
            </div>
          </div>

          <div className="chat-history">
            {mensagensChat.map((msg) => (
              <div key={msg.id} className={`chat-message ${msg.papel === 'usuario' ? 'message-user' : 'message-liz'}`}>
                {msg.papel === 'ia' && <img src="/assistente_avatar.svg" alt="Estrela" className="msg-avatar-mini" />}
                <div className="message-bubble">
                  <strong>{msg.papel === 'usuario' ? 'Você (Pai/Mãe)' : 'Estrela - Parceira Pedagógica'}</strong>
                  <p>{msg.texto}</p>
                  <span className="msg-time">{msg.horario}</span>
                </div>
              </div>
            ))}
            {ouvindoPergunta && (
              <div className="chat-message message-liz">
                <img src="/assistente_avatar.svg" alt="Estrela" className="msg-avatar-mini" />
                <div className="message-bubble typing">
                  <span className="dot"></span>
                  <span className="dot"></span>
                  <span className="dot"></span>
                </div>
              </div>
            )}
          </div>

          <form onSubmit={enviarMensagem} className="chat-input-area">
            <input 
              type="text" 
              placeholder="Digite sua dúvida como se fosse um pai ou diretor..." 
              value={mensagem} 
              onChange={(e) => setMensagem(e.target.value)} 
              disabled={ouvindoPergunta}
            />
            <button type="submit" disabled={ouvindoPergunta || !mensagem.trim()} className="btn-enviar">
              Enviar
            </button>
          </form>
        </div>
        
        <div className="showcase-bastidores">
          <h3>🧠 Bastidores da IA (RAG)</h3>
          <p>Veja como o Cérebro Isolado da Estrela está raciocinando nesta demonstração:</p>
          <ul>
            <li><strong>Creche ID:</strong> `tia_liz_001`</li>
            <li><strong>Permissão Tática:</strong> Resposta para Família</li>
            <li><strong>Memória Vetorial Acessada:</strong></li>
          </ul>
          <div className="rag-box">
            <code>[Arquivo da Memória: ppp-tializ.pdf]</code>
            <p>"É proibido açúcar até os 3 anos... As refeições seguem o modelo BLW."</p>
            <p>"Nos 3 primeiros dias, a presença familiar na sala é obrigatória..."</p>
          </div>
          <div className="info-comercial">
            <p><strong>Argumento de Vendas:</strong> Demonstre esta tela ao gestor escolar. Peça para ele mesmo perguntar sobre "como lidar com doces". Depois, explique que na escola dele a assistente — batizada e treinada pela própria escola — responderá usando APENAS o documento da escola dele!</p>
          </div>
        </div>
      </main>
    </div>
  );
}
